/** Rules for a nursery whose paid subscription has ended (view-only "lapsed" state). */
export const LAPSED_MANAGER_ROLES = ["super_admin", "admin"] as const;

export function canUseLapsedNursery(role: string | null | undefined): boolean {
  return !!role && (LAPSED_MANAGER_ROLES as readonly string[]).includes(role);
}

/** Only Children, Staff, the records download and Plan & Billing stay open. */
export function isLapsedPathAllowed(pathname: string): boolean {
  return /^\/(children|staff)(\/[^/]+)?$/.test(pathname)
    || pathname === "/records" || pathname === "/settings" || pathname === "/upgrade";
}

/** Midnight (UK time) after the day the subscription ended. */
export function lapseStartsAt(endedAt: Date): Date {
  const ukDate = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit" }).format(endedAt);
  const [y, m, d] = ukDate.split("-").map(Number);
  // Try both possible UK offsets and pick the one landing on 00:00 London time.
  for (const offset of [0, 1]) {
    const candidate = new Date(Date.UTC(y, m - 1, d + 1, -offset));
    const h = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", hour: "2-digit", hourCycle: "h23" }).format(candidate);
    if (h === "00") return candidate;
  }
  return new Date(Date.UTC(y, m - 1, d + 1));
}

const ACTION_WORDS = /\b(add|edit|archive|restore|import|export|save|delete|remove|upload|new|create|invite|print|download|csv|log|change|move|assign|sign|send|review|complete|approve|decline|refer|convert)\b/i;
/** True for controls that change or export information, which a lapsed nursery cannot use. */
export function isLapsedBlockedAction(label: string): boolean {
  return ACTION_WORDS.test(label);
}
